module.exports = __webpack_public_path__ + "static/media/asgard.fbfa6f38.gif";